import { Flex, Spinner } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import { useFormColors } from './FormThemeContext'

interface WizardActionsProps {
  cancelPath: string
  isFirst: boolean
  isLast: boolean
  isEditing: boolean
  isSubmitting?: boolean
  onBack: () => void
  onSaveAndExit?: () => void
}

export function WizardActions({
  cancelPath,
  isFirst,
  isLast,
  isEditing,
  isSubmitting,
  onBack,
  onSaveAndExit,
}: WizardActionsProps) {
  const navigate = useNavigate()
  const c = useFormColors()

  const outlineStyle: React.CSSProperties = {
    padding: '0.75rem 1.5rem',
    borderRadius: '0.75rem',
    color: c.textMuted,
    background: 'transparent',
    border: `1px solid ${c.border}`,
    cursor: 'pointer',
  }

  const primaryStyle: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    padding: '0.75rem 1.5rem',
    background: c.accent,
    color: 'white',
    borderRadius: '0.75rem',
    border: 'none',
    fontWeight: 'bold',
    cursor: isSubmitting ? 'not-allowed' : 'pointer',
    opacity: isSubmitting ? 0.7 : 1,
  }

  const saveExitStyle: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    padding: '0.75rem 1.5rem',
    background: 'transparent',
    color: c.accent,
    borderRadius: '0.75rem',
    border: `1px solid ${c.accent}`,
    fontWeight: 'bold',
    cursor: isSubmitting ? 'not-allowed' : 'pointer',
    opacity: isSubmitting ? 0.7 : 1,
  }

  // Determine primary button label
  const primaryLabel = isEditing
    ? undefined // no primary submit in editing mode (only "Guardar y Salir")
    : isLast
      ? 'Guardar'
      : 'Siguiente'

  return (
    <Flex alignItems="center" gap={3} mt={6}>
      {/* Cancel - always left */}
      <button
        type="button"
        style={{ ...outlineStyle, marginRight: 'auto' }}
        onClick={() => navigate(cancelPath)}
      >
        Cancelar
      </button>

      {/* Back - when not first tab */}
      {!isFirst && (
        <button type="button" style={outlineStyle} onClick={onBack}>
          Atras
        </button>
      )}

      {/* Primary action (Siguiente / Guardar) - only in non-editing mode */}
      {!isEditing && primaryLabel && (
        <button type="submit" disabled={isSubmitting} style={primaryStyle}>
          {isSubmitting && <Spinner size="sm" color="white" />}
          {primaryLabel}
        </button>
      )}

      {/* Guardar y Salir - only in editing mode */}
      {isEditing && onSaveAndExit && (
        <button
          type="button"
          disabled={isSubmitting}
          style={saveExitStyle}
          onClick={onSaveAndExit}
        >
          {isSubmitting && <Spinner size="sm" />}
          Guardar y Salir
        </button>
      )}
    </Flex>
  )
}
